// extracted by mini-css-extract-plugin
export default {"content":"About_content__0BcXE","imagesContainer":"About_imagesContainer__r2lzk","image":"About_image__x7hHQ","title":"About_title__9I1Qt","text":"About_text__ISqxP"};